import styled from "styled-components";

const ClearFix = styled.div`
  width: 100%;
  height: 100%;

  & .avatar-uploader > .ant-upload {
    width: 100%;
    height: 100%;
    margin-right: 0px;
    margin-bottom: 0px;
    border: 1px dashed #756969;
    background-color: #eceef0;
  }
`;

const PreviewImage = styled.div`
  height: 100%;
  position: relative;
  border-radius: 50%;
  margin: 0;

  & img {
    width: 100%;
    height: 100%;
  }

  & .imgDiv {
    background-color: #ffffff;
    height: 100%;
    position: relative;
    display: block;
  }

  & .img-uploaded {
  }
`;

const ContainerCamera = styled.div`
  background: rgb(255, 255, 255);
  bottom: 0px;
  right: 0px;
  display: flex;
  padding: 6px;
  box-shadow: 2px 6px 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  border-radius: 50%;

  & i {
    color: #000000;
  }
`;

export { ClearFix, PreviewImage, ContainerCamera };
